import { Box, Text, VStack } from '@chakra-ui/react';

import type { DefaultTFuncReturn } from 'i18next';
import EddyAnimation from './EddyAnimation';

interface AIAgentIconShadowProps {
  text?: string | DefaultTFuncReturn;
  helpText?: string | DefaultTFuncReturn;
  secondaryHelpText?: string | DefaultTFuncReturn;
}

export default function AIAgentIconShadow({
  text,
  helpText,
  secondaryHelpText,
}: AIAgentIconShadowProps) {
  return (
    <VStack spacing={0} alignItems="center" textAlign="center">
      <Box marginBottom={-4}>
        <EddyAnimation size={140} />
      </Box>

      <VStack spacing={2}>
        {text && (
          <Text
            fontSize="28px"
            fontWeight={600}
            style={{
              background: 'linear-gradient(to right, #C567EE, #FCB8AE)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {text}
          </Text>
        )}

        {helpText && (
          <Text fontSize="14px" fontWeight={500} color="baseBlack">
            {helpText}
          </Text>
        )}

        {secondaryHelpText && (
          <Text fontSize="14px" fontWeight={500} color="baseBlack">
            {secondaryHelpText}
          </Text>
        )}
      </VStack>
    </VStack>
  );
}
